import theme from '@/common/styles/mui-theme';

const resetPasswordStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    m: 'auto',
    width: '100%',
    minHeight: '100%',
    position: 'relative',
  },
  formWrapper: {
    margin: 'auto',
    width: '100%',
    px: theme.spacing(5),
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '500px',
      px: 0,
    },
  },
  form: {
    width: '100%',
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '440px',
      mx: 'auto',
      px: 0,
    },
  },
  successIcon: {
    display: 'block',
    margin: `0 auto ${theme.spacing(8)}`,
  },
  description: {
    ...theme.typography.body1,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    mt: theme.spacing(4),
    mb: theme.spacing(10),
  },
  warning: {
    mt: theme.spacing(8),
    textAlign: 'center',
    fontSize: '18px',
    lineHeight: '26px',
    letterSpacing: '0.15px',
    color: theme.palette.text.secondary,
  },
  inlineLink: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    fontWeight: 500,
  },
};

export default resetPasswordStyles;
